import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'

// Components
import { Button, Text } from '../../../../Components'

// Helpers
import { openLink } from '../../../../api/iframe/requests'
import { dispatchEvent } from '../../../../helpers/tagManager'
import { SignUpMagicLinkSent } from '../../../../constants/trackingEvents'

// Constants
import { EMAIL_PROVIDERS } from '../../../../constants/navigation'

// Context
import { useSignUpProvider } from '../SignUpContext'

// Styles
import styles from './MagicLink.module.scss'

const MagicLink = () => {
  const { GMAIL, OUTLOOK, YAHOO } = EMAIL_PROVIDERS

  const {
    formState: { email },
    iFramed,
  } = useSignUpProvider()

  const linkProps = provider => {
    const { url } = provider

    if (iFramed) {
      return {
        onClick: () => openLink(url),
      }
    }
    return {
      target: '_blank',
      rel: 'noopener noreferrer',
      href: url,
    }
  }

  useEffect(() => {
    dispatchEvent(SignUpMagicLinkSent)
  }, [])

  return (
    <>
      <div className={styles.header}>
        <Text
          weight='light'
          size='xl'
          variant='neutralCool'
          variantCount='900'
          className={styles.headline}
        >
          <FormattedMessage
            id='NewBuyerSignUp.completeStep.salutation'
            defaultMessage='Magic Link Sent!'
          />
        </Text>
      </div>
      <div className={styles.helper}>
        <Text size='s' variant='neutralCool' variantCount='700'>
          <FormattedMessage
            id='NewBuyerSignUp.completeStep.helper'
            defaultMessage='We just sent you an email with a link that instantly signs you in! It might take a few minutes to arrive.'
          />
        </Text>
      </div>
      <div className={styles.sentTo}>
        <Text size='s' variant='neutralCool' variantCount='700'>
          <FormattedMessage
            id='NewBuyerSignUp.completeStep.sentTo'
            defaultMessage='Sent to'
          />
        </Text>
        <Button className={styles.email}>{email}</Button>
      </div>
      <div className={styles.email}>
        <Text size='s' variant='neutralCool' variantCount='700'>
          <FormattedMessage
            id='NewBuyerSignUp.completeStep.openEmail'
            defaultMessage='Open email in new tab'
          />
        </Text>
        <div className={styles.btnRow}>
          <Button element='a' {...linkProps(GMAIL)}>
            {GMAIL.title}
          </Button>
          <Button element='a' {...linkProps(OUTLOOK)}>
            {OUTLOOK.title}
          </Button>
          <Button element='a' {...linkProps(YAHOO)}>
            {YAHOO.title}
          </Button>
        </div>
      </div>
    </>
  )
}

export default MagicLink
